import { render, staticRenderFns } from "./ProjectConfigurationComment.vue?vue&type=template&id=5189683f&scoped=true&"
import script from "./ProjectConfigurationComment.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5189683f",
  null
  
)

export default component.exports